export default __webpack_public_path__ + "static/media/P2P.5c02bb72.avif";